import React from 'react';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import Typography, { TypographyProps } from 'src/app/atoms/Typography/Typography';
import CheckItemTextList, { CheckItemTextListProps } from '../CheckItemTextList/CheckItemTextList';

export interface FeatureBlockProps {
  headlineProps: TypographyProps;
  checkItemTextListProps: CheckItemTextListProps;
}

const FeatureBlock = ({ headlineProps, checkItemTextListProps }: FeatureBlockProps): JSX.Element => (
  <Stack
    direction='column'
    gap='spacing-xl'
    justify='center'
    align='flex-start'
  >
    <Typography {...headlineProps} />
    <CheckItemTextList {...checkItemTextListProps} />
  </Stack>
);

export default FeatureBlock;
